import Vue from 'vue'

Vue.prototype.consumeNotifications = function (group) {
  this.$root.$emit('consumeNotifications', group)
}

Vue.prototype.addNotification = function (consume, arg) {
  this.$store.commit('addNotification', arg)
  if (consume) {
    this.consumeNotifications(arg.group)
  }
}
